import { useEffect } from 'react';
import Index from '@/pages/index';
import { setLanguage } from 'react-switch-lang';

export default function Sv() {
	const lang = 'sv';
	useEffect(
		() => {
			document.documentElement.lang = lang;
		},
		[ lang ]
	);
	setLanguage('sv');
	return <Index />;
}
